import { render, staticRenderFns } from "./DashboardSeller.vue?vue&type=template&id=0bf49812"
import script from "./DashboardSeller.vue?vue&type=script&lang=js"
export * from "./DashboardSeller.vue?vue&type=script&lang=js"
import style0 from "./DashboardSeller.vue?vue&type=style&index=0&id=0bf49812&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports